import { render, staticRenderFns } from "./Classe.vue?vue&type=template&id=7e314a1c&"
import script from "./Classe.vue?vue&type=script&lang=js&"
export * from "./Classe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports